export const truncPrice = (price: number) =>
  Number(price.toString().match(/^\d+(?:\.\d{0,2})?/))
